// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2BF_R","right":"Footer_right__2PfI5","buttons":"Footer_buttons__1REgE"};